<template>
  <div
    class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 transition-colors duration-200 relative"
  >
    <!-- Watermark -->
    <div
      class="fixed inset-0 flex items-center justify-center pointer-events-none z-0 opacity-[0.03] dark:opacity-[0.02]"
    >
      <img
        src="/assets/images/atqan-logo.svg"
        alt="Atqan Watermark"
        class="w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 transform rotate-[-30deg]"
      />
    </div>
    <!-- Main content -->
    <div class="relative z-10">
      <AppHeader />
      <main class="container mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-4 sm:py-6 md:py-8 mt-14 sm:mt-16 min-h-[calc(100vh-3.5rem)] sm:min-h-[calc(100vh-4rem)]">
        <slot />
      </main>
      <UNotifications />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

const { initializeLanguage } = useLanguage();

// Initialize language and direction on mount
onMounted(() => {
  initializeLanguage();
});
</script>
